import { Component, Input } from '@angular/core';

@Component({
  selector: 'phoenix-read-only-banner',
  templateUrl: './read-only-banner.component.html',
  standalone: false,
})
export class ReadOnlyBannerComponent {
  @Input() isReadOnly = false;
  @Input() aria = '';
  @Input() message = 'Read Only';
  @Input() toolTip = 'Configured permissions grant you read-only access';
}
